import Vue from 'vue'
import {ptracGetEntities} from '@/utilities/ptracApi'
import {make} from 'vuex-pathify'

const initialState = {
  city: null,
  county: null,
  state: 'TX',
  zip: null,
  streetNumber: null,
  suiteNumber: null,
  buildingNumber: null,
  floorNumber: null,
  streetName: null,
  jurisdiction: null,
  lotNumber: null,
  blockNumber: null,
  legalDescription: null,
  legalSubdivisionId: null,
  phase: null,
  section: null,
  lat: null,
  lng: null,
  usingLatLngOfCity: false
}

const state = Vue.util.extend({}, initialState)

const getters = make.getters(state)
const mutations = make.mutations(state)

mutations.all = (state, payload) => {
  state.city = payload.city
  state.county = payload.county
  state.state = payload.state
  state.zip = payload.zip
  state.streetNumber = payload.streetNumber
  state.suiteNumber = payload.suiteNumber
  state.buildingNumber = payload.buildingNumber
  state.floorNumber = payload.floorNumber
  state.streetName = payload.streetName
  state.jurisdiction = payload.jurisdiction
  state.lotNumber = payload.lotNumber
  state.blockNumber = payload.blockNumber
  state.legalDescription = payload.legalDescription
  state.legalSubdivisionId = payload.legalSubdivisionId
  state.phase = payload.phase
  state.section = payload.section
  state.lat = payload.lat
  state.lng = payload.lng
  state.usingLatLngOfCity = payload.usingLatLngOfCity

  Vue.prototype.$eventHub.$emit('projectAddressLoaded', payload)
}

mutations.reset = (state) => {
  for (let f in state) {
    Vue.set(state, f, initialState[f])
  }
}

getters.all = (state) => {
  return state
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchCityByCityName(state, payload) {
      return await ptracGetEntities(`cities/search/findOneByNameIgnoreCase?name=${payload}`)
    }
  }
}
